module.exports = __webpack_public_path__ + "media/character_open.30eeedc0.wav";